// extracted by mini-css-extract-plugin
export default {"templateCard":"fb7864943a27","updateInfo":"aa3ee2915b42","templateCardContent":"bc85f9c371c1"};